import { render, staticRenderFns } from "./Forgetpassword.vue?vue&type=template&id=37a6b9be&"
import script from "./Forgetpassword.vue?vue&type=script&lang=js&"
export * from "./Forgetpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports